import InsurancechannelInfoModal from './insurancechannel-info-modal.vue'
export default InsurancechannelInfoModal
